import apiClient from "@/api/client";

export default {
  fetchProducts() {
    return apiClient.get("/products");
  },
};
